<template>
	<div class="checkout">
		<top-header></top-header>
        <!--<div class="breadcrumb-section mb-5">
            <b-container>
                <b-row>
                    <b-col class="text-left">
                        <h5 class="mt-3 mb-3">CHECKOUT</h5>		
                    </b-col>
                    <b-col class="text-right">
                        <h6 class="mt-3 mb-3">HOME / CHECKOUT</h6>		
                    </b-col>
                </b-row>
            </b-container>
        </div> -->
        <b-container v-if="$root.cart.subtotal == 0" class="pb-3">
            <b-alert show variant="danger">Shopping cart is empty!</b-alert>
        </b-container> 
		<b-container v-else>
			
            <b-row class="mb-5">
				<b-col  sm="12" md="8" lg="8" xl="8">
					<div class="accordion" role="tablist">
						<b-card no-body class="mb-1">
						  <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle.login variant="info" :disabled="!(tabIndex==1)">
							<div class="stepnnumber">1</div>
							<span class="steptitle"> Login</span>
						  </b-card-header>
						  <b-collapse id="login" visible accordion="my-accordion" role="tabpanel">
							<b-card-body>
							  <!--<b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
							  <b-card-text>asasasd</b-card-text>-->
							  <b-row>
								<b-col cols="12" lg="6" md="12" sm="12">
								<ul class="p-0">
										
										<li v-if="$root.customer_info.user_id == 0"><p class="mb-2"  v-if="logiform==0">Returning customer? <b-link @click="logiform=1" >Click here to login</b-link> </p>
										<!-- $root.showLoginModal()-->
											<span v-if="logiform==1">
											<logininpage-modal></logininpage-modal>
											<b-link @click="logiform=0" class="cancelLink">Cancel</b-link>
											
											</span>
											<div v-if="logiform==1" class="forgetpassch">
												<b-link href="/forgotpassword" >Forgot Password?</b-link>
											</div>
										
										</li>
										<li v-else >
											<b-row >
												<b-col cols="4" class="pr-0"> Name</b-col>
												<b-col > <small>{{$root.customer_info.username}}</small></b-col>
											</b-row>
											<b-row >
												<b-col cols="4" class="pr-0"> Email</b-col>
												<b-col > <small>{{$root.customer_info.email}}</small></b-col>
											</b-row>
											<b-row class="pt-3">
												<b-col ><b-link class="btn-solid btn2 btnCheckout"  v-b-toggle.delivery-address v-on:mouseover="tabIndex=2">Continue Checkout</b-link></b-col>
											</b-row>
										</li>
										<li v-if="$root.customer_info.user_id == 0 && logiform==0"> 
											<b-row class="pt-3">
												<b-col >
												<!-- <b-link class="btn-solid btn2 btnCheckout" @click="tabIndex=2" v-b-toggle.delivery-address >Continue as a Guest</b-link> -->
												<b-link class="btn-solid btn2 btnCheckout continueAsAGuest" v-b-toggle.delivery-address  v-on:mouseover="tabIndex=2">Continue as a Guest</b-link>
												</b-col>
												
											</b-row>
								
										</li>
										
										</ul>
								
									
								</b-col>
								<b-col cols="12" lg="6" md="12" sm="12">
										<span>Advantages of our secure login</span>
										<ul class="p-0">
										<li><i class="fa fa-hand-o-right" aria-hidden="true"></i> <small>Easily Track Orders, Hassle free Returns</small></li>
										<li ><i class="fa fa-hand-o-right" aria-hidden="true"></i> <small>Get Relevant Alerts and Recommendation</small></li>
										<li ><i class="fa fa-hand-o-right" aria-hidden="true"></i> <small>Wishlist, Reviews, Ratings and more.</small></li>
										</ul>
									 
									  
								</b-col>
							  </b-row>
							</b-card-body>
						  </b-collapse>
						</b-card>

						<b-card no-body class="mb-1">
						  <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle.delivery-address variant="info" :disabled="!(tabIndex==2)">
						 <!-- :disabled="!(tabIndex==2)" -->
							<div class="stepnnumber">2</div>
							<span class="steptitle"> Delivery Address</span>
						  </b-card-header>
						  <b-collapse id="delivery-address" accordion="my-accordion" role="tabpanel">
							<b-card-body>
								<!-- ==============Shipping Address ====================== -->
								
								<span v-if="$root.customer_info.user_id >0">
								<b-row  v-for="(itemSa, index) in shippingaddressData" :key="itemSa.id" class="bb pt-2 pb-2">
										<b-col cols="10" lg="11" md="10" sm="10" >
											<b-form-group>
											  <b-form-radio v-model="pickaddressValue"  name="pickaddress" :value="itemSa.id" v-on:change="setDelivertaddress(itemSa.id,index),showAddaddress=0"> 
											  <span class="ml-1 mr-2">{{itemSa.firstname+' '+itemSa.lastname}} </span><span>{{itemSa.phone}}</span> <p class="p-0"><small> {{itemSa.address}}{{itemSa.city}} ,{{itemSa.state}} ,{{itemSa.pincode}} </small></p></b-form-radio>											 
											</b-form-group>
											<p v-if="pickaddressValue==itemSa.id">
					<b-link class="btn-solid btn2 " v-b-toggle.order-summary v-on:mouseover="tabIndex=3">Deliver Here</b-link>
												
											</p>
											
											
										</b-col>
										<b-col cols="1" lg="1" md="1" sm="1" >
										<b-link @click="deleteshippingaddressrow(itemSa.id)"> <i aria-hidden="true" class="fa fa-trash" v-b-tooltip.hover title="Remove Shipping Adress" placement="bottom"></i></b-link>
										</b-col>
										
								</b-row>
								
								
								
								<b-row  v-if="showAddaddress==0" class=" pt-2 pb-2 mt-2 mb-2" style="background:#F9F9F9">
									<b-col>										
										<b-link @click="showAddaddress=1"> <i aria-hidden="true" class="fa fa-plus"></i> ADD A NEW ADDRESS</b-link>
									</b-col>										
								</b-row>
										
								
								
									<div v-if="showAddaddress==1" class="billing-form p-3" style="background:#F9F9F9">
										<p class="font-xl font-500">SHIPPING DETAILS </p>
										<b-row>
											<b-col cols="12" lg="6" md="12" sm="12">
												<b-form-group :state="shippingaddressState.firstname" label="First name" label-for="sa-firstname" invalid-feedback="First name is required!">
													<b-form-input id="sa-firstname" v-model="shippingaddress.firstname" :state="shippingaddressState.firstname" @focusin="shippingaddressState.firstname = null"></b-form-input>
												</b-form-group>
											</b-col>
											<b-col cols="12" lg="6" md="12" sm="12">
												<b-form-group :state="shippingaddressState.lastname" label="Last name" label-for="sa-lastname" invalid-feedback="Last name is required!">
													<b-form-input id="sa-lastname" v-model="shippingaddress.lastname" :state="shippingaddressState.lastname" @focusin="shippingaddressState.lastname = null"></b-form-input>
												</b-form-group>
											</b-col>
										</b-row>
										<b-row>
											<b-col cols="12" lg="6" md="12" sm="12">
												<b-form-group :state="shippingaddressState.email" label="Email" label-for="sa-email" invalid-feedback="Email should be valid!">
													<b-form-input id="sa-email" v-model="shippingaddress.email" :state="shippingaddressState.email" @focusin="shippingaddressState.email = null"></b-form-input>
												</b-form-group>
											</b-col>
											<b-col cols="12" lg="6" md="12" sm="12">
												<b-form-group :state="shippingaddressState.phone" label="Phone" label-for="sa-phone" invalid-feedback="Phone is required!">
													<b-form-input id="sa-phone" v-model="shippingaddress.phone" :state="shippingaddressState.phone" @focusin="shippingaddressState.phone = null"></b-form-input>
												</b-form-group>
											</b-col>
										</b-row>
										<b-row>
											<b-col >
												<b-form-group :state="shippingaddressState.address" label="Street address" label-for="sa-address" invalid-feedback="Street address is required!">
													<b-form-input id="sa-address" v-model="shippingaddress.address" :state="shippingaddressState.address" @focusin="shippingaddressState.address = null"></b-form-input>
												</b-form-group>
											</b-col>
										</b-row>
										<b-row>
											<b-col>
												<b-form-group :state="shippingaddressState.city" label="City" label-for="sa-city" invalid-feedback="City is required!">
													<b-form-input id="sa-city" v-model="shippingaddress.city" :state="shippingaddressState.city" @focusin="shippingaddressState.city = null"></b-form-input>
												</b-form-group>
											</b-col>
											<b-col>
												<b-form-group :state="shippingaddressState.state" label="State" label-for="sa-state" invalid-feedback="State is required!">
													<b-form-input id="sa-state" v-model="shippingaddress.state" :state="shippingaddressState.state" @focusin="shippingaddressState.state = null"></b-form-input>
												</b-form-group>
											</b-col>
										</b-row>
										<b-row>
											<b-col>
												<b-form-group :state="shippingaddressState.pincode" label="Pincode" label-for="sa-pincode" invalid-feedback="Pincode is required!">
													<b-form-input id="sa-pincode" v-model="shippingaddress.pincode" :state="shippingaddressState.pincode"></b-form-input>
												</b-form-group>
											</b-col>
											<b-col> 
												<b-form-group label="Country" label-for="sa-country">
													<b-form-select id="sa-country" v-model="shippingaddress.country">
														<b-form-select-option value="IN" selected>India</b-form-select-option>
													</b-form-select>
												</b-form-group>
											</b-col>
										</b-row>
										<b-row>
											<b-col cols="12" lg="6" md="12" sm="12">
												
											</b-col>
											<b-col cols="12" lg="6" md="12" sm="12">
												<b-link class="btn pr-3 pl-3 float-right" @click="showAddaddress=0" style="color:#ff4c3b;">Cancel</b-link>
												<b-link class="btn-solid btn2 float-right" @click="addShipping()" >Save Address</b-link>
												
												
											</b-col>
										</b-row>
									</div>
								</span>
							<!-- ==================================== -->
							<span v-bind:class="{ displaynone: (activuserId > 0) }" > 
								<div class="billing-form p-3" style="background:#F9F9F9">
									<!--<p class="font-xl font-500">BILLING DETAILS </p> -->
									<p class="font-xl font-500">SHIPPING DETAILS </p>
									<b-row>
										<b-col cols="12" lg="6" md="12" sm="12">
											<b-form-group :state="billingState.firstname" label="First name" label-for="fn-input" invalid-feedback="First name is required!">
												<b-form-input id="fn-input" v-model="$root.customer_info.billing.firstname" :state="billingState.firstname" @focusin="billingState.firstname = null"></b-form-input>
											</b-form-group>
										</b-col >
										<b-col cols="12" lg="6" md="12" sm="12">
											<b-form-group :state="billingState.lastname" label="Last name" label-for="ln-input" invalid-feedback="Last name is required!">
												<b-form-input id="ln-input" v-model="$root.customer_info.billing.lastname" :state="billingState.lastname" @focusin="billingState.lastname = null"></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="12" lg="6" md="12" sm="12">
											<b-form-group :state="billingState.email" label="Email" label-for="sab-input" :invalid-feedback="billingStateEmailInvalid">
											
												<b-form-input id="sab-input" v-model="$root.customer_info.billing.email" :state="billingState.email" @focusin="billingState.email = null,billingStateEmailInvalidBtn=0"></b-form-input>
												<span v-if="billingStateEmailInvalidBtn==1">
												
												<b-button variant="outline-primary" size="sm" style="padding: 0px 2px 0px 3px;
    color: #dc3545;border-color: #ab41ee;" href="https://www.alluraa.com/login" >Login Now!</b-button> </span>
											</b-form-group>
											
											
										</b-col>
										<b-col cols="12" lg="6" md="12" sm="12">
											<b-form-group :state="billingState.phone" label="Phone" label-for="phone-input" invalid-feedback="Phone is required!">
												<b-form-input id="phone-input" v-model="$root.customer_info.billing.phone" :state="billingState.phone" @focusin="billingState.phone = null"></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group :state="billingState.address" label="Street address" label-for="sa-input" invalid-feedback="Street address is required!">
												<b-form-input id="sa-input" v-model="$root.customer_info.billing.address" :state="billingState.address" @focusin="billingState.address = null"></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group :state="billingState.city" label="City" label-for="city-input" invalid-feedback="City is required!">
												<b-form-input id="city-input" v-model="$root.customer_info.billing.city" :state="billingState.city" @focusin="billingState.city = null"></b-form-input>
											</b-form-group>
										</b-col>
										<b-col>
											<b-form-group :state="billingState.state" label="State" label-for="state-input" invalid-feedback="State is required!">
												<b-form-input id="state-input" v-model="$root.customer_info.billing.state" :state="billingState.state" @focusin="billingState.state = null"></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group :state="billingState.pincode" label="Pincode" label-for="pc-input" invalid-feedback="Pincode is required!">
												<b-form-input id="pc-input" v-model="$root.customer_info.billing.pincode" :state="billingState.pincode"></b-form-input>
											</b-form-group>
										</b-col>
										<b-col>
											<b-form-group label="Country" label-for="country-input">
												<b-form-select id="country-input" v-model="$root.customer_info.billing.country">
													<b-form-select-option value="IN" selected>India</b-form-select-option>
												</b-form-select>
											</b-form-group>
										</b-col>
									</b-row>
									
									
								</div>
								<p class="my-2">
									<b-row>
										<b-col>
									<b-form-checkbox id="checkbox-a" v-model="createaccount" value="1" unchecked-value="0" v-if="$root.customer_info.user_id == 0"> 
										Create an account?
									</b-form-checkbox> 
									</b-col>
									<b-col>
									<!-- <b-link class="btn-solid btn2 float-right" @click="checkBillingAddredd"  v-b-toggle.order-summary  >Deliver Here</b-link>-->
									<b-link v-if="tabIndex!=3" class="btn-solid btn2 float-right" @click="checkBillingAddredd" >Deliver Here</b-link>
									<b-link v-else class="btn-solid btn2 float-right deliverHere" v-b-toggle.order-summary  >Deliver Here</b-link>
									
									
									
									
									
									</b-col>
									</b-row>
								</p>
								<!-- <p class="mb-2">
									<b-form-checkbox id="checkbox-s" v-model="shipping_new" value="1" unchecked-value="0" @change="updateShipping()">
										Ship to different address?
									</b-form-checkbox>
								</p> -->
								<div class="shipping-form p-3" v-if="shipping_new[0] == 1" style="background:#F9F9F9">
									<p class="font-xl font-500">SHIPPING DETAILS </p>
									<b-row>
										<b-col>
											<b-form-group :state="shippingState.firstname" label="First name" label-for="fn-input" invalid-feedback="First name is required!">
												<b-form-input id="fn-input" v-model="$root.customer_info.shipping.firstname" :state="shippingState.firstname"></b-form-input>
											</b-form-group>
										</b-col>
										<b-col>
											<b-form-group :state="shippingState.lastname" label="Last name" label-for="ln-input" invalid-feedback="Last name is required!">
												<b-form-input id="ln-input" v-model="$root.customer_info.shipping.lastname" :state="shippingState.lastname"></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group :state="shippingState.phone" label="Phone" label-for="sa-input" invalid-feedback="Phone is required!">
												<b-form-input id="sa-input" v-model="$root.customer_info.shipping.phone" :state="shippingState.phone"></b-form-input>
											</b-form-group>
										</b-col>
										<b-col>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group :state="shippingState.address" label="Street address" label-for="sa-input" invalid-feedback="Street address is required!">
												<b-form-input id="sa-input" v-model="$root.customer_info.shipping.address" :state="shippingState.address"></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group :state="shippingState.city" label="City" label-for="citys-input" invalid-feedback="City is required!">
												<b-form-input id="citys-inputs" v-model="$root.customer_info.shipping.city" :state="shippingState.city"></b-form-input>
											</b-form-group>
										</b-col>
										<b-col>
											<b-form-group :state="shippingState.state" label="State" label-for="state-input" invalid-feedback="State is required!">
												<b-form-input id="state-input" v-model="$root.customer_info.shipping.state" :state="shippingState.state"></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group :state="shippingState.pincode" label="Postcode" label-for="pincode-input" invalid-feedback="Pincode is required!">
												<b-form-input id="pincode-input" v-model="$root.customer_info.shipping.pincode" :state="shippingState.pincode"></b-form-input>
											</b-form-group>
										</b-col>
										<b-col>
											<b-form-group label="Country" label-for="country-input">
												<b-form-select id="country-input" v-model="$root.customer_info.shipping.country">
													<b-form-select-option value="IN" selected>India</b-form-select-option>
												</b-form-select>
											</b-form-group>
										</b-col>
									</b-row>
								</div>
							</span> 
							</b-card-body>
						  </b-collapse>
						</b-card>

						<b-card no-body class="mb-1">
						  <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle.order-summary variant="info" :disabled="!(tabIndex==3)">
							
							<div class="stepnnumber">3</div>
							<span class="steptitle"> Order Summary</span>
							
						  </b-card-header>
						  <b-collapse id="order-summary" accordion="my-accordion" role="tabpanel">
							<b-card-body>
							    <b-row v-for="item in $root.cart.items" :key="item.id" class="bb pt-2 pb-2">
									<b-col cols="12" lg="6" md="12" sm="12">
										<b-media tag="li">
											<template v-slot:aside>
												<b-img :src="$root.MEDIAAPI+'tool/get_image?size=64x64&src='+item.image" width="64" alt="placeholder" class="border"></b-img>
											</template>
											<h5 class="mt-0 mb-1">{{item.title}}</h5>
											<cart-variant :cartItemslist="item" ></cart-variant>
											<span v-if="item.special_price>0 && item.special_price!=null">
											<p class="font-md my-1">M.R.P.: <del>{{$root.currency()+$root.tofixed(item.price, 2)}}</del></p>
											<p class="font-md mt-1 mb-3">You Save: {{$root.currency()+$root.tofixed(item.price - item.special_price, 2)}} ({{$root.currency()+$root.tofixed((item.price - item.special_price)*100/item.price, 0)}}% off)</p>
											</span>
											<span v-else>
												<p class="font-md my-1">M.R.P.: {{$root.currency()+$root.tofixed(item.price, 2)}}</p>
											</span>
											
											
										</b-media>
									</b-col>
									<b-col cols="6" lg="3" md="6" sm="6" class="text-right px-0 mbqty">
										<span class="mr-2"><b-form-spinbutton id="sb-inline" size="sm" min="1" :max="item.stock_qty" step="1" :value="item.qty" @change="setCouponbox(),$root.updateCartqty(item, $event)" inline></b-form-spinbutton> </span>
										<b-link @click="$root.removeCart(item.id)"> <i aria-hidden="true" class="fa fa-trash" v-b-tooltip.hover title="Remove Item" placement="bottom"></i></b-link>
									</b-col>
									<b-col cols="6" lg="3" md="6" sm="6"  class="text-right">
										<span v-if="item.special_price>0 && item.special_price!=null">{{$root.currency()+$root.tofixed(item.special_price * item.qty, 2)}}</span>
										<span v-else>{{$root.currency()+$root.tofixed(item.price * item.qty, 2)}}</span>
									</b-col>
								</b-row>
								
								<p class="p-1">
									<span v-if="showCoupnboxApply==1" class="mt-2">
									<small v-if="showCoupnbox==0">Changed the Quantity? <b-link style="color:#c85df7" @click="showCoupnbox=1">Apply Coupon Again!</b-link></small>
								</span>
									<coupon-panel v-if="showCoupnbox==1" style="width: 41%;margin-left: 58%;"></coupon-panel>
									
									
									
									
								<b-link class="btn-solid btn2 float-right"  v-b-toggle.payment-options v-on:mouseover="tabIndex=4" @click="createRazorPayorder">CONTINUE</b-link>
								</p>
							</b-card-body>
						  </b-collapse>
						</b-card>
						<b-card no-body class="mb-1">
						  <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle.payment-options variant="info" :disabled="!(tabIndex==4)">
							<div class="stepnnumber">4</div>
							<span class="steptitle">Payment Options</span>
						  </b-card-header>
						  <b-collapse id="payment-options" accordion="my-accordion" role="tabpanel">
							<b-card-body>
							<!--<b-card-text>Payment Options</b-card-text>-->
							  <div class="pb-0 pt-2 px-3" style="background:#F9F9F9">
									<b-form-group label="Payment Mode" >
										
										<b-form-radio v-model="paymentmode" name="payment-type" value="Card">Credit / Debit / Net Banking</b-form-radio> 
										<b-form-radio v-model="paymentmode" name="payment-type" value="cod" @change="$root.applywallet($root.customer_info['wallet'].total_blance,'remove'),createRazorPayorder()">Cash on delivery</b-form-radio> 
									</b-form-group>
								</div>
								<div class="pb-0 pt-2 px-3" style="background:#F9F9F9" v-if="$root.customer_info.user_id>0">
								<span v-if="$root.customer_info['wallet'].total_blance>0 && paymentmode=='Card'">
									<b-row class="pb-2" v-if="$root.cart.wallet_balance_applied==0">
										<b-col cols="12" lg="7" md="12" sm="12"  class="pr-0 pt-2 font-sm">
										Redeem Wallet Amount ( <small>{{$root.currency()+$root.tofixed($root.customer_info['wallet'].total_blance, 2)}} </small>)</b-col>
										<b-col cols="12" lg="3" md="12" sm="12"  class="text-right">
										<b-link  style="color:#c85df7" @click="$root.applywallet($root.customer_info['wallet'].total_blance,'apply'),createRazorPayorder()">APPLY</b-link>
										
										</b-col>
									</b-row >	
									<b-row class="pb-2" v-else>
										<b-col cols="12" lg="7" md="12" sm="12"  class="pr-0 pt-2 font-sm">
										Remove Redeem Amount </b-col>
										<b-col cols="12" lg="3" md="12" sm="12"  class="text-right">
										<b-link style="color:#c85df7" @click="$root.applywallet($root.customer_info['wallet'].total_blance,'remove'),createRazorPayorder()">REMOVE</b-link>
										
										</b-col>
									</b-row >	
								</span>
								
								</div>
								<div class="pt-2">
								<b-row class="pb-2" v-if="paymentmode=='Card'">
									<b-col cols="12" lg="7" md="12" sm="12"  class="pr-0 pt-2 font-xl">Total Payable : {{$root.currency()+$root.tofixed($root.cart.totalprice, 2)}}</b-col>
									
									<b-col v-if="$root.cart.totalprice==0" cols="12" lg="3" md="12" sm="12"  class="text-right" ><b-button class="btn-solid btn2 float-right placeOrder" @click="submitOrder()">Place Order</b-button></b-col>
									<b-col v-else cols="12" lg="3" md="12" sm="12"  class="text-right"><b-button class="btn-solid btn2 float-right placeOrder" @click="payByRozorpay()">Place Order</b-button></b-col>
									
									<!--<button @click="payByRozorpay">Pay</button>-->
									
									<!-- <b-col  cols="12" lg="3" md="12" sm="12"  class="text-right" ><b-button class="btn-solid btn2 float-right" @click="submitOrder()">Place Order All</b-button></b-col> -->
								</b-row>
								<b-row class="pb-2" v-else>
									<b-col cols="12" lg="7" md="12" sm="12"  class="pr-0 pt-2 font-xl">Total Payable : {{$root.currency()+$root.tofixed($root.cart.totalprice, 2)}}</b-col>
									
									<b-col v-if="$root.cart.totalprice==0" cols="12" lg="3" md="12" sm="12"  class="text-right" ><b-button class="btn-solid btn2 float-right placeOrder" @click="submitOrder()">Place Order</b-button></b-col>
									<b-col v-else cols="12" lg="3" md="12" sm="12"  class="text-right"><b-button class="btn-solid btn2 float-right placeOrder" @click="submitOrder()">Place Order</b-button></b-col>
									
									<!--<button @click="payByRozorpay">Pay</button>-->
									
									<!-- <b-col  cols="12" lg="3" md="12" sm="12"  class="text-right" ><b-button class="btn-solid btn2 float-right" @click="submitOrder()">Place Order All</b-button></b-col> -->
								</b-row>
								</div>
							</b-card-body>
						  </b-collapse>
						</b-card>
					  </div>
				
				
				
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4" class="pricedetails">
					<div class="card nav" id="checkoutpriceDetails">
						<header class="card-header">Price details</header>
						
						<div class="card-body">
							<b-row class="pt-2">
								<b-col cols="7" class="pr-0"> Subtotal ({{$root.cart.quantity}} item):</b-col>
								<b-col class="text-right">{{$root.currency()+$root.tofixed($root.cart.subtotal, 2)}}</b-col>
							</b-row>
						   
							<b-row class="pt-2">
								<b-col cols="7" class="pr-0">Shipping charge:<br><small>(Avail free shipping above purchase amount {{$root.currency()+$root.tofixed($root.free_shipping,2)}})</small></b-col>
								<b-col class="text-right">{{$root.currency()+$root.tofixed($root.cart.shipping, 2)}}</b-col>
							</b-row>
							<b-row class="pt-2" v-if="$root.cart.wallet_balance_applied>0">
								<b-col cols="8" class="pr-0">Wallet Balance:<small>(Applied)</small></b-col>
								<b-col class="text-right">-{{$root.currency()+$root.tofixed($root.cart.wallet_balance_applied, 2)}}</b-col>
							</b-row>
							
							<b-row class="pt-2" v-if="$root.cart.coupon_applied>0">
								<b-col cols="8" class="pr-0">Coupon <small>(Applied): </small> </b-col>
								<b-col class="text-right">-{{$root.currency()+$root.tofixed($root.cart.coupon.discount, 2)}} <h3 style="font-size: 11px;font-weight:400;">You Saved</h3></b-col>
							</b-row>
							<b-row class="pt-4 pb-4 bodertop mt-3">
								<b-col cols="7" class="pr-0">Total Payable</b-col>
								<b-col class="text-right">{{$root.currency()+$root.tofixed($root.cart.totalprice, 2)}}</b-col>
							</b-row>
							<!--<b-form-group label="Shipping Type" class="mt-4">
								<b-form-radio v-model="shippingtype" name="shipping-type" value="1">Free Shipping (above {{$root.currency()+'450.00'}})</b-form-radio>
								<b-form-radio v-model="shippingtype" name="shipping-type" value="2">Next Day Delivery ({{$root.currency()+'70.00'}})</b-form-radio>
							</b-form-group>-->
							<div class="pb-0 pt-2 px-3" style="background:#F9F9F9">
								<b-row class=" pb-2">
									<b-col cols="7" class="pr-0">Payment Mode</b-col>
									<b-col class="text-right" style="text-transform: uppercase;font-size: 16px;">{{paymentmode}}</b-col>
								</b-row>
							</div>
							
						
						</div>
						<!--<footer class="card-footer">Card Footer</footer>-->
						
					</div>
                </b-col>
            </b-row>
		</b-container>
		<top-footer></top-footer>
	</div>
</template>
<script>
import Header from "@/components/header-checkout.vue";
import Footer from "@/components/footer.vue";
import Logininpage from "@/components/logininpage.vue";
import CartVariant from "@/components/cartVariant.vue";
import CouponPanel from "@/components/couponPanel.vue";

import '../assets/checkout.scss';
export default {
	name: 'Checkout',
	beforeCreate: function() {
        document.body.className = 'checkout';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		"logininpage-modal": Logininpage,
		"cart-variant": CartVariant,
		"coupon-panel": CouponPanel,
	},
	mounted(){
        let s2 = document.createElement('script');
        s2.setAttribute('src', 'https://checkout.razorpay.com/v1/checkout.js');
		document.head.appendChild(s2);
		/*this.rzp1 = new Razorpay(this.options);*/
		
		
		
        this.initload();
		
		/* ============Sticky LeftPanel===============*/
		  this.$nextTick(function(){
			window.addEventListener("scroll", function(){
			  var navbar = document.getElementById("checkoutpriceDetails")
			  var nav_classes = navbar.classList
			  if(document.documentElement.scrollTop >= 150) {
				if (nav_classes.contains("shrink") === false) {
				  nav_classes.toggle("shrink");
				}
			  }
			  else {
				if (nav_classes.contains("shrink") === true) {
				  nav_classes.toggle("shrink");
				}
			  }
			})
		  })
		this.activuserId= this.$root.customer_info.user_id;
	  /*=========================================*/
    },
	data() {
		return{
            country: 'IN',
			orderId:'',
			paymentStatus:'',
            billing: {
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                address: '',
                city: '',
                state: '',
                pincode: '',
                country: 'IN',
            },
            shipping: {
                firstname: '',
                lastname: '',
                phone: '',
                address: '',
                city: '',
                state: '',
                pincode: '',
                country: 'IN',
            },
            billingState: {
                firstname: null,
                lastname: null,
                email: null,
                phone: null,
                address: null,
                city: null,
                state: null,
                pincode: null
            },
            shippingState: {
                firstname: null,
                lastname: null,
                phone: null,
                address: null,
                city: null,
                state: null,
                pincode: null
            },
			shippingaddress: {
                firstname:'',
                lastname:'',
				email:'',
                phone:'',
                address:'',
                city:'',
                state:'',
                pincode:''
            },
			shippingaddressState: {
                firstname: null,
                lastname: null,
                email: null,
                phone: null,
                address: null,
                city: null,
                state: null,
                pincode: null
            },
			shippingaddressData:[],
			pickaddressValue:'',
			showAddaddress:0,
            createaccount: 0,
            shipping_new: 0,
			modal_data: {
				price: 0,
				special_price: 0
            },

            orderfields: [
                { key: 'title', label: 'TITLE'},
                { key: 'subtotal', label: 'SUBTOTAL', class: 'text-right'},
            ],
            shippingtype: 1,
           // paymentmode: 2,
            paymentmode:'Card',
			activuserId:0,
            //thumbnailProps: { blank: false, width: 80, height: 0, class: 'm1' },
            //thumbnailProps:'',
            placeorderurl: this.$root.WEBURL+'placeorder', 
            placeorderguesurl: this.$root.WEBURL+'placeorderguestuser', 
            //placeorderurl: this.$root.WEBURL+'placeorderMOd', 
            placeorderurlV: this.$root.WEBURL+'verification',
            userdetailurl: this.$root.WEBURL+'userdetails',
            addshippingurl: this.$root.WEBURL+'addshippingaddress',
            getshippingurl: this.$root.WEBURL+'getshippingaddress',
            getOrderIdrazorpayUrl: this.$root.WEBURL+'getOrderIdrazorpay',
            deleteshippingurl: this.$root.WEBURL+'deleteshippingaddress',
            guestUservalidationUrl: this.$root.WEBURL+'guestUservalidation',
			tabIndex:1,
			logiform:0,
			selectedItem: {
				short_description: '',
				product_data:{}, 
				tier_price:[], 
				gallery_images:["","","",""]
			},
			billingStateEmailInvalid:'Email is required!',
			billingStateEmailInvalidBtn:0,
			showCoupnbox:'',
			showCoupnboxApply:0,
			
		};
	},
	methods: {
        updateShipping(){
            var self = this;
            self.$root.customer_info.shipping = Object.assign({}, self.$root.customer_info.billing);
        },
		submitOrder(){
			var valid = true;
			if(this.$root.customer_info.billing.firstname.length < 3) {
				this.billingState.firstname = false;
				valid = false;
			}else this.billingState.firstname = true;

			if(this.$root.customer_info.billing.lastname.length < 3) {
				this.billingState.lastname = false;
				valid = false;
			}else this.billingState.lastname = true;

			if(this.$root.customer_info.billing.email.length < 10) {
				this.billingState.email = false;
				valid = false;
			}else this.billingState.email = true;

			if(this.$root.customer_info.billing.phone.length < 10) {
				this.billingState.phone = false;
				valid = false;
			}else this.billingState.phone = true;

			if(this.$root.customer_info.billing.address.length < 4) {
				this.billingState.address = false;
				valid = false;
			}else this.billingState.address = true;
			
			if(this.$root.customer_info.billing.city.length < 3) {
				this.billingState.city = false;
				valid = false;
			}else this.billingState.city = true;
			
			if(this.$root.customer_info.billing.state.length < 3) {
				this.billingState.state = false;
				valid = false;
			}else this.billingState.state = true;
			
			if(this.$root.customer_info.billing.pincode.length < 6) {
				this.billingState.pincode = false;
				valid = false;
			}else this.billingState.pincode = true;
			
			if(this.shipping_new == '1'){
				
				if(this.$root.customer_info.shipping.firstname.length < 3) {
					this.shippingState.firstname = false;
					valid = false;
				}else this.shippingState.firstname = true;

				if(this.$root.customer_info.shipping.lastname.length < 3) {
					this.shippingState.lastname = false;
					valid = false;
				}else this.shippingState.lastname = true;

				if(this.$root.customer_info.shipping.phone.length < 10) {
					this.shippingState.phone = false;
					valid = false;
				}else this.shippingState.phone = true;

				if(this.$root.customer_info.shipping.address.length < 4) {
					this.shippingState.address = false;
					valid = false;
				}else this.shippingState.address = true;
				
				if(this.$root.customer_info.shipping.city.length < 3) {
					this.shippingState.city = false;
					valid = false;
				}else this.shippingState.city = true;
				
				if(this.$root.customer_info.shipping.state.length < 3) {
					this.shippingState.state = false;
					valid = false;
				}else this.shippingState.state = true;
				
				if(this.$root.customer_info.shipping.pincode.length < 6) {
					this.shippingState.pincode = false;
					valid = false;
				}else this.shippingState.pincode = true;
			}

			if(valid){
				var self = this;

				if(this.shipping_new != '1'){
					self.$root.customer_info.shipping = Object.assign({}, self.$root.customer_info.billing);
				}
				//if(this.$root.customer_info != ''){
				//    self.createaccount = 0;
			   // }
				
				//var totalPayOut = 0;
				if(self.$root.cart.totalprice==0){
					self.paymentmode ='Wallet';					
				}else{
					if(self.$root.cart.wallet_balance_applied>0){
						self.paymentmode =self.paymentmode+' + Wallet';
					}
					
				}
				

				var walletbalanceapplied=0;
				var wallet_balance_applied_wb=0;
				var walletbalanceapplied_cb=0;
				if(self.$root.cart.wallet_balance_applied>0){
						walletbalanceapplied	= self.$root.cart.wallet_balance_applied;
						wallet_balance_applied_wb =walletbalanceapplied;
						
						/* Calculate Wallet Amount & CASHBACK AMOUNT Spelit */
						var wB= self.$root.customer_info['wallet'].blance;
						//var wB_cb= self.$root.customer_info['wallet'].blance_cb;
						//var wTotalB= self.$root.customer_info['wallet'].total_blance;
						//var redimWb = Number(walletbalanceapplied)-Number(wB);
						
						if(wB==walletbalanceapplied){
							
							walletbalanceapplied_cb =0;
							
						}else if(wB>walletbalanceapplied){
							walletbalanceapplied_cb =0;
						}else if(wB<walletbalanceapplied){
							
							walletbalanceapplied_cb =Number(self.$root.cart.wallet_balance_applied)-Number(wB);
							wallet_balance_applied_wb = wB;
						}else{
						console.log('NoWallet');
						}
						
					}
				
				console.log("walletbalanceapplied:"+walletbalanceapplied+";walletbalanceapplied_cb:"+walletbalanceapplied_cb);
				
					var orderplaceUrl = self.placeorderurl;
					if(self.$root.customer_info.user_id == 0){
						orderplaceUrl = self.placeorderguesurl;
					}
				self.axios.post(orderplaceUrl, {
					accesskey: self.$root.customer_info.access_key,
					billing: self.$root.customer_info.billing,
					shipping: self.$root.customer_info.shipping,
					referer_id: self.$session.get('share_user_id'),
					order_items: self.$root.cart.items,
					payment_mode: self.paymentmode,
					wallet_balance_applied: walletbalanceapplied,
					wallet_balance_applied_wb: wallet_balance_applied_wb,
					wallet_balance_applied_cb: walletbalanceapplied_cb,
					create_account: self.createaccount,
					orderId:self.orderId,
					paymentStatus:self.paymentStatus,
					coupon_applied:self.$root.cart.coupon_applied,
					coupon:self.$root.cart.coupon,
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						//console.log(response.data.result);
						//console.log("OdId:"+response.data.result.ordergroupId);
						//self.$root.resetCart();
						self.$session.set('orderplaceId', self.orderId);
						//self.$session.set('orderplaceId','devD');
						self.$router.push('/order-success');
						
						//console.log(self.share_data);
						//alert(response.data.message);
					}else if(response.data.error == 9){
						self.$root.forceLogout(response.data.message);
					}else{
						alert(response.data.message);
					}
				})
				.catch(function (error) {
					alert(error);
				});
			}
			

		},
		checkBillingAddredd(){
			var valid = true;
			if(this.$root.customer_info.billing.firstname.length < 3) {
				this.billingState.firstname = false;
				valid = false;
			}else this.billingState.firstname = true;

			if(this.$root.customer_info.billing.lastname.length < 3) {
				this.billingState.lastname = false;
				valid = false;
			}else this.billingState.lastname = true;

			/* if(this.$root.customer_info.billing.email.length < 10) {
				this.billingState.email = false;
				valid = false;
			}else this.billingState.email = true;*/
			//console.log('dddd'+this.$root.customer_info.billing.email);

			
			if(!this.validateemail(this.$root.customer_info.billing.email)){
				  this.billingState.email = false;
					valid = false;
				}else{
				   this.billingState.email = true;
				}

			if(this.$root.customer_info.billing.phone.length < 10) {
				this.billingState.phone = false;
				valid = false;
			}else this.billingState.phone = true;

			if(this.$root.customer_info.billing.address.length < 4) {
				this.billingState.address = false;
				valid = false;
			}else this.billingState.address = true;
			
			if(this.$root.customer_info.billing.city.length < 3) {
				this.billingState.city = false;
				valid = false;
			}else this.billingState.city = true;
			
			if(this.$root.customer_info.billing.state.length < 3) {
				this.billingState.state = false;
				valid = false;
			}else this.billingState.state = true;
			
			if(this.$root.customer_info.billing.pincode.length < 6) {
				this.billingState.pincode = false;
				valid = false;
			}else this.billingState.pincode = true;
			

			if(valid){
			var self = this;
			if(self.createaccount==1){
				//var selfOb=this;
				console.log('inCon');
					/* User Varification Email & phone List getshippingurl*/
					self.axios.post(self.guestUservalidationUrl, {
						email:self.$root.customer_info.billing.email,
						mobile:self.$root.customer_info.billing.phone,
					})
					.then(function (response) {
					
						if(response.data.error == 0 || response.data.error == '0'){						
							self.billingState.email = true;
							self.billingStateEmailInvalidBtn=0;
							self.tabIndex=3;
							self.showAddaddress=0;
						}else{
							self.billingState.email = false;
							self.billingStateEmailInvalid='Email/Phone already registered.';
							self.billingStateEmailInvalidBtn=1;
							valid = false;
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
					
					   //this.billingState.email = true;
					
				
				
				}else{
					self.tabIndex=3;
					self.showAddaddress=0;
				}

				
				
				
				
				/*self.tabIndex=3;
				self.showAddaddress=0;*/
				console.log('Mydata CLICK');
			}
			

		},
		addShipping(){
				//alert('len'+this.shippingaddress.firstname.length);
				var valid = true;
				if(this.shippingaddress.firstname.length < 3) {
					this.shippingaddressState.firstname = false;
					valid = false;
				}else this.shippingaddressState.firstname = true;

				if(this.shippingaddress.lastname.length < 3) {
					this.shippingaddressState.lastname = false;
					valid = false;
				}else this.shippingaddressState.lastname = true;
				
				if(!this.validateemail(this.shippingaddress.email)){
				  valid = false;
				  this.shippingaddressState.email = false;
				}else{
				  this.shippingaddressState.email = true;
				}
				/*if(this.shippingaddress.email.length < 10) {
					this.shippingaddressState.email = false;
					valid = false;
				}else this.shippingaddressState.email = true;*/

				if(this.shippingaddress.phone.length < 10) {
					this.shippingaddressState.phone = false;
					valid = false;
				}else this.shippingaddressState.phone = true;

				if(this.shippingaddress.address.length < 4) {
					this.shippingaddressState.address = false;
					valid = false;
				}else this.shippingaddressState.address = true;
				
				if(this.shippingaddress.city.length < 3) {
					this.shippingaddressState.city = false;
					valid = false;
				}else this.shippingaddressState.city = true;
				
				if(this.shippingaddress.state.length < 3) {
					this.shippingaddressState.state = false;
					valid = false;
				}else this.shippingaddressState.state = true;
				
				if(this.shippingaddress.pincode.length < 6) {
					this.shippingaddressState.pincode = false;
					valid = false;
				}else this.shippingaddressState.pincode = true;
				

				if(valid){
					var self = this;
					self.axios.post(self.addshippingurl, {
						accesskey: self.$root.customer_info.access_key,
						billing: self.shippingaddress						
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							//console.log("ddd"+response.data);
							self.shippingaddressData = response.data.result.shippingaddressData;
							self.showAddaddress=0;
							
							self.shippingaddress={
								firstname:'',
								lastname:'',
								email:'',
								phone:'',
								address:'',
								city:'',
								state:'',
								pincode:''
							};
							self.shippingaddressState={
								firstname: null,
								lastname: null,
								email: null,
								phone: null,
								address: null,
								city: null,
								state: null,
								pincode: null
							};
							
							
							//self.$root.resetCart();
							//self.$router.push('/order-success');
							//console.log(self.share_data);
							//alert(response.data.message);
						}else if(response.data.error == 9){
							self.$root.forceLogout(response.data.message);
						}else{
							alert(response.data.message);
						}
					})
					.catch(function (error) {
						alert(error);
					});
				}
				

			},
			validateemail(email){
				var atposition=email.indexOf("@");  
				var dotposition=email.lastIndexOf(".");  
				if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
				return false;  
				}else{
				return true;
				}
		},
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			
			var self = this;
			//self.createRazorPayorder();
            //console.log('--------------------');
           // console.log(JSON.stringify(self.$root.cart));

            if(self.$root.customer_info.access_key != ''){
                self.createaccount = 0;

                self.axios.post(self.userdetailurl, {
                    accesskey: self.$root.customer_info.access_key
                })
                .then(function (response) {
                    if(response.data.error == 0 || response.data.error == '0'){
                        self.$root.customer_info.billing = response.data.result.billing;
                        self.$root.customer_info.shipping = response.data.result.shipping;

                        
                        //console.log(response.data.result.info);
                        
                        //self.related_products = response.data.result.related_products;
                        //console.log(self.share_data);
                    }else if(response.data.error == 9){
                        self.$root.forceLogout(response.data.message);
                    }
                    
                })
                .catch(function (error) {
                    alert(error);
                });
				
				/* User Shipping Address List*/
				self.axios.post(self.getshippingurl, {
                    accesskey: self.$root.customer_info.access_key
                })
                .then(function (response) {
                    if(response.data.error == 0 || response.data.error == '0'){
                       self.shippingaddressData = response.data.result.shippingaddressData;
                       // self.$root.customer_info.billing = response.data.result.billing;
                        //console.log(response.data.result.info);
                        
                        //self.related_products = response.data.result.related_products;
                        //console.log(self.share_data);
                    }else if(response.data.error == 9){
                        self.$root.forceLogout(response.data.message);
                    }
                    
                })
                .catch(function (error) {
                    alert(error);
                });
				
				
				
            }else{
                self.createaccount = 1;
            }
			
		},
		deleteshippingaddressrow(sid){
		var self = this;
			//console.log(sid);
			self.axios.post(self.deleteshippingurl, {
				accesskey: self.$root.customer_info.access_key,
				rowId:sid
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
				   self.shippingaddressData = response.data.result.shippingaddressData;
				  }else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		setDelivertaddress(selectOptId,indexKey){
			var self = this;
			console.log(selectOptId+'--'+indexKey);
			self.$root.customer_info.billing = self.shippingaddressData[indexKey];
			
		},
		createRazorPayorder(){
			var self = this;
			/* ============== Razorpay Order Create================= */
				var totalPayOut = 0;
				if(self.$root.cart.totalprice==0){
					totalPayOut = Number(self.$root.cart.subtotal)+Number(self.$root.cart.shipping);
				}else{
					totalPayOut = self.$root.cart.totalprice;
				}
				
				
				self.axios.post(self.getOrderIdrazorpayUrl, {
                    accesskey: self.$root.customer_info.access_key,
					//totalAmount:self.$root.cart.totalprice,
					totalAmount:totalPayOut,
					orderItem:JSON.stringify(self.$root.cart.items),
					billing: self.$root.customer_info.billing,
					shipping: self.$root.customer_info.shipping,
                })
                .then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
					   self.orderId = response.data.result.orderId;
					  }else{
						
						self.$bvToast.toast(response.data.message, {
						title: 'Order',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
						});
					}
				
                    
					
                })
                .catch(function (error) {
                    alert(error);
                });
			
			/* ===============================*/
		
		},
		payByRozorpay(e){
			var self = this;
			/*var optionsVAl = {
				"key": "rzp_test_Dli68phylc1NAZ", // Enter the Key ID generated from the Dashboard
				"amount": "10000", // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
				"currency": "INR",
				"name": "Acme Corp",
				"description": "Test Transaction",
				"image": "https://www.alluraa.com/media/images/logo.png",
				"order_id": "order_9A33XWu170gUtt", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
				"callback_url": "https://eneqd3r9zrjok.x.pipedream.net/",
				"prefill": {
					"name": "Gaurav Kumar",
					"email": "gaurav.kumar@example.com",
					"contact": "9999999999"
				},
				"notes": {
					"address": "Razorpay Corporate Office"
				},
				"theme": {
					"color": "#3399cc"
				}
			};*/
			
			



			var clientName ='';
			var clientEmail ='';
			var clientContact ='';
			if(self.$root.customer_info.user_id>0){
				clientName = self.$root.customer_info.username;
				clientEmail = self.$root.customer_info.email;
				clientContact = self.$root.customer_info.mobile;
			}else{
				var billingData = self.$root.customer_info.billing;
				clientName = billingData.firstname+' '+billingData.lastname;
				clientEmail = billingData.email;
				clientContact = billingData.phone;
			}
			
			
			var totalAmount=self.$root.cart.totalprice;
			var razorpayOrderId = self.orderId;
			//orderItem:JSON.stringify(self.$root.cart.items),
			var options = {
				  description: 'Payment',
				  image: 'https://www.alluraa.com/media/images/alluraa_logo.png',
				  currency: 'INR',
				  //key: 'rzp_test_Dli68phylc1NAZ',
				  key: 'rzp_live_jwtNA0XfLCGShw',
				  amount: (totalAmount*100),
				  name: 'Alluraa',
				  order_id: razorpayOrderId, 
				  prefill: {
					email: clientEmail,
					contact: clientContact,
					name: clientName
				  },
				  theme: {
					color: '#528FF0'
				  }
				};
				
					//console.log(options);
					options.handler = function (response){
						response.shopping_order_id = razorpayOrderId;
						self.paymentStatus = JSON.stringify(response);
						//console.log("PaymentSucess"+JSON.stringify(response));
					
					
						/* self.axios.post(self.placeorderurlV, {
							accesskey: self.$root.customer_info.access_key,
							responseRe:response
						})
						.then(function (response) {
							console.log('Dev'+response);
						})
						.catch(function (error) {
							alert(error);
						}); */
					
					
					
						
					
						/*
						document.getElementById('razorpay_payment_id').value = response.razorpay_payment_id;
						document.getElementById('razorpay_signature').value = response.razorpay_signature;
						document.getElementById('razorpay_order_id').value = response.razorpay_order_id;
						document.razorpayform.submit();*/
						self.submitOrder();
						
					};
					options.theme.image_padding = false;
					options.modal = {
						ondismiss: function() {
						
							 console.log("This code runs when the popup is closed");
							/*$("#inprocessMess").hide();
							$("#rzp-button1").show();*/
						},
						// Boolean indicating whether pressing escape key 
						// should close the checkout form. (default: true)
						escape: true,
						// Boolean indicating whether clicking translucent blank
						// space outside checkout form should close the form. (default: false)
						backdropclose: false
					};

				var rzp1 = new window.Razorpay(options);
				rzp1.open();
				e.preventDefault();
		
		
		
		},
		vueCheckme(){
			console.log('ffff');
		},
		setCouponbox(){
			if(this.$root.cart.coupon_applied==1){
				this.showCoupnboxApply =1;
			}
		}
		
		
		
		
	},
	metaInfo() {
		return{
			title: 'checkout | Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
				{ name: 'description', content: 'alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
}
</script>
<!-- <script src="https://checkout.razorpay.com/v1/checkout.js"></script> -->